import gql from 'graphql-tag';

import { SORT } from 'src/app/constants/sort';
import { PROGRAM_PORTRAIT_FRAGMENT, ProgramPortrait } from 'src/app/models/program';
import { USER_ID_QUERY, USER_PLAYLIST_FRAGMENT, UserIdOnly, UserPlaylists } from 'src/app/models/user';
import { VideoCard, VIDEO_CARD_FRAGMENT } from 'src/app/models/video';

export interface VideoItem extends VideoCard {
  publishedAt: string;
}

export interface MyQueryResult {
  user?: UserIdOnly & UserPlaylists;
  programs?: {
    id: string;
    items: ProgramPortrait[];
  };
  videos?: {
    id: string;
    items: VideoItem[];
    nextCursor: string;
    total: number;
  };
  communityThumbnail?: string;
}

export const GRAPHQL_QUERY = gql`
  query ForCommunityPage($sortBy: GQLSortType!, $cursor: GQLCursor) {
    user {
      ${USER_ID_QUERY}
      ...UserPlaylists
    }
    programs(criteria: { category: "Community", sortBy: ${SORT.POPULAR} }) {
      id
      items {
        ...ProgramPortrait
      }
    }
    videos(criteria: { category: "Community", sortBy: $sortBy }, pagination: { cursor: $cursor, limit: 8 }) {
      id
      items {
        ...VideoCard
        publishedAt
      }
      nextCursor
      total
    }
    communityThumbnail
  }
  ${USER_PLAYLIST_FRAGMENT}
  ${PROGRAM_PORTRAIT_FRAGMENT}
  ${VIDEO_CARD_FRAGMENT}
`;

export const GRAPHQL_ADD_WATCHLIST_MUTATION = gql`
  mutation ForCommunityWatchlist($id: ID!) {
    addVideoToWatchlist(videoId: $id) {
      isInWatchlist
    }
  }
`;
